export const KINDS = [
  { value: "normal", label: "Satış (e-Arşiv / e-Fatura)" },
  { value: "tevkifat", label: "Tevkifatlı" },
  { value: "ihracat", label: "İhracat (e-Fatura)" },
];

export const CURRENCIES = [
  { value: "EUR", label: "€ Euro" },
  { value: "USD", label: "$ Dolar" },
  { value: "TRL", label: "₺ TL" },
  { value: "GBP", label: "£ Sterlin" },
];
export const CUR_SYMBOL = { EUR: "€", USD: "$", TRL: "₺", GBP: "£" };

export const VAT_RATES = [20, 10, 1, 0];

export const EXEMPTION_CODES = [
  { code: "301", label: "301 · Mal ihracatı (11/1-a)" },
  { code: "302", label: "302 · Hizmet ihracatı (11/1-a)" },
  { code: "350", label: "350 · Diğer istisnalar (açıklama zorunlu)" },
  { code: "351", label: "351 · İstisna olmayan diğer (KDV %0)" },
  { code: "250", label: "250 · Diğer kısmi istisna (açıklama zorunlu)" },
];

export const PAYMENT_TYPES = [
  { value: "ODEMEARACISI", label: "Ödeme aracısı (GYG / Viator vb.)" },
  { value: "KREDIKARTI/BANKAKARTI", label: "Kredi / banka kartı" },
  { value: "EFT/HAVALE", label: "EFT / Havale" },
  { value: "KAPIDAODEME", label: "Kapıda / yerinde ödeme" },
];

export const STATUS = {
  creating: { label: "Oluşturuluyor", cls: "bg-slate-100 text-slate-700" },
  draft: { label: "Taslak", cls: "bg-amber-100 text-amber-800" },
  processing: { label: "Resmileşiyor…", cls: "bg-blue-100 text-blue-800" },
  approved: { label: "Onaylı", cls: "bg-emerald-100 text-emerald-800" },
  error: { label: "Hata", cls: "bg-red-100 text-red-700" },
  failed: { label: "Başarısız", cls: "bg-red-100 text-red-700" },
  cancelled: { label: "İptal", cls: "bg-gray-200 text-gray-600 line-through" },
  deleted: { label: "Silindi", cls: "bg-gray-100 text-gray-400 line-through" },
};

export const DOC_LABEL = { e_archive: "e-Arşiv", e_invoice: "e-Fatura" };

export const today = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`; };

const r4 = (n) => Math.round(n * 10000) / 10000;

export const pctTableFor = (rules, split) => (split.mode === "percent" ? rules.pct_tables?.[split.tier] : null);

function percentLines(rules, table, tier, split, P, qty) {
  const pcts = table[(split.transfer ? "t" : "") + (split.alcohol ? "a" : "") || "none"] || {};
  const comps = (rules.components || []).filter((c) => Number(pcts[c.key]) > 0);
  let used = 0;
  return comps.map((c, i) => {
    const unit = i === comps.length - 1 ? Math.round((P - used) * 100) / 100 : Math.round(P * Number(pcts[c.key])) / 100;
    used += unit;
    return { description: tier.labels?.[c.key] || c.label, quantity: qty, unit_gross: unit, vat_rate: Number(c.vat) };
  });
}

export function splitLines(rules, split, pax) {
  const P = Number(split.per_person) || 0;
  const qty = Number(pax) || 1;
  const tier = (rules.tiers || []).find((t) => t.key === split.tier) || (rules.tiers || [])[0] || { amounts: {} };
  const table = pctTableFor(rules, split);
  if (table) return percentLines(rules, table, tier, split, P, qty);
  const lines = [];
  const commission = r4((P * (Number(split.commission_pct) || 0)) / 100);
  if (commission > 0) lines.push({ description: rules.commission_label, note: rules.commission_note || null, quantity: qty, unit_gross: commission, vat_rate: 0 });
  let used = commission;
  for (const c of rules.components || []) {
    if ((c.when === "transfer" && !split.transfer) || (c.when === "alcohol" && !split.alcohol)) continue;
    const amt = Number(tier.amounts?.[c.key]) || 0;
    if (amt <= 0) continue;
    lines.push({ description: tier.labels?.[c.key] || c.label, quantity: qty, unit_gross: amt, vat_rate: Number(c.vat) });
    used += amt;
  }
  const service = r4(P - used);
  const fixed = lines.filter((l) => l.vat_rate > 0);
  const room = P - commission;
  if (service < 0 && room > 0 && fixed.length) {
    const k = room / (used - commission);
    let acc = 0;
    fixed.forEach((l, i) => { l.unit_gross = i === fixed.length - 1 ? r4(room - acc) : r4(l.unit_gross * k); acc += l.unit_gross; });
    return lines;
  }
  if (service !== 0) lines.push({ description: rules.service_label, quantity: qty, unit_gross: service, vat_rate: 0 });
  return lines;
}

export function formFromPrefill(p) {
  const b = p.booking;
  const infants = Number(b.infant_count) || 0;
  const pax = Math.max(1, (b.total_pax || 1) - infants);
  const rules = p.rules;
  const split = {
    tier: p.detected.tier, transfer: p.detected.transfer, alcohol: p.detected.alcohol,
    commission_pct: p.channel_rule.commission_pct, mode: p.channel_rule.split_mode || "commission", discount_pct: p.price_discount_pct || 0, per_person: p.amount ? r4(p.amount / pax) : "",
  };
  return {
    booking_id: b.id,
    customer_name: p.clean_name || b.customer_name || "",
    customer_email: (b.customer_email || "").includes("reply.getyourguide") ? "" : b.customer_email || "",
    customer_phone: b.customer_phone || "",
    contact_type: "person",
    contact_prefix: p.channel_rule.prefix || "",
    tax_number: p.is_abroad ? rules.foreign_tax_number || "22222222222" : "11111111111",
    tax_office: "",
    country: p.country || b.customer_country || "",
    city: "",
    district: "",
    address: "",
    is_abroad: p.is_abroad,
    issue_date: today(),
    currency: p.currency,
    exchange_rate: p.currency === "TRL" ? 1 : p.exchange_rate || "",
    item_type: "invoice",
    kind: "normal",
    description: b.option_name || b.product_name || "Tur hizmeti",
    pax,
    split,
    lines: splitLines(rules, split, pax),
    vat_exemption_reason_code: rules.exemption_code || "302",
    vat_exemption_reason: rules.exemption_reason || "",
    vat_withholding_rate: "",
    vat_withholding_code: "",
    invoice_note: `Rezervasyon ${b.confirmation_code || ""} · Tur tarihi ${b.booking_date || ""} · ${pax} kişi${infants ? ` + ${infants} bebek` : ""}`,
    order_no: b.confirmation_code || "",
    internet_sale: true,
    sale_url: p.internet_sale.url,
    payment_type: p.internet_sale.payment_type,
    payment_platform: p.internet_sale.payment_platform,
    payment_date: p.internet_sale.payment_date,
    einvoice_scenario: "basic",
    mark_paid: false,
    payment_account_id: "",
  };
}

export function applyKind(f, kind) {
  return { ...f, kind, item_type: kind === "ihracat" ? "export" : "invoice" };
}

export function calcTotals(f) {
  const rate = f.currency === "TRL" ? 1 : Number(f.exchange_rate) || 0;
  const byVat = {};
  let total = 0;
  for (const l of f.lines || []) {
    const g = (Number(l.quantity) || 0) * (Number(l.unit_gross) || 0);
    const v = Number(l.vat_rate) || 0;
    const net = g / (1 + v / 100);
    byVat[v] = (byVat[v] || 0) + (g - net);
    total += g;
  }
  const vat = Object.values(byVat).reduce((a, b) => a + b, 0);
  return { net: total - vat, vat, byVat, total, tl: total * rate };
}

export function toPayload(f, formalize) {
  const num = (v) => (v === "" || v === null || v === undefined ? null : Number(v));
  const { split, pax, ...rest } = f;
  return {
    ...rest,
    split,
    pax: num(pax),
    exchange_rate: f.currency === "TRL" ? null : num(f.exchange_rate),
    lines: (f.lines || []).filter((l) => Number(l.unit_gross) !== 0).map((l) => ({
      description: l.description, note: l.note || null, quantity: num(l.quantity), unit_gross: num(l.unit_gross), vat_rate: num(l.vat_rate),
    })),
    vat_withholding_rate: f.kind === "tevkifat" ? num(f.vat_withholding_rate) : null,
    vat_withholding_code: f.kind === "tevkifat" ? f.vat_withholding_code : null,
    vat_exemption_reason_code: f.vat_exemption_reason_code || null,
    contact_prefix: f.contact_prefix || null,
    payment_account_id: f.payment_account_id || null,
    formalize,
  };
}

export const money = (n, cur) => `${(Number(n) || 0).toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${CUR_SYMBOL[cur] || cur || ""}`;
